import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './FreeShippingProgress.styled';
import ProgressBar from '../../../ProgressBar/ProgressBar';
import { formatPrice } from '../../../../util/localize';

/**
 * Displays copy about free shipping and a progress bar based on order total in relation to a threshold.
 */
const FreeShippingProgress = ({
  currencyCode,
  currencySymbol,
  threshold,
  total,
  method,
  ...props
}) => {
  const renderMessage = (currency, symbol) => {
    let message;

    if (threshold === 0) {
      message = `Free ${method} shipping & free returns on all orders.`;
    } else if (!total) {
      message = `Free ${method} shipping for orders over ${symbol}${threshold} and free returns on all orders.`;
    } else if (total < threshold) {
      message = `You’re ${formatPrice(
        threshold - total,
        currency
      )} away from free ${method} shipping.`;
    } else {
      message = `Score. Your order qualifies for free ${method} shipping.`;
    }

    return message;
  };

  return (
    <Styled.FreeShippingProgress {...props}>
      <Styled.Message>
        {renderMessage(currencyCode, currencySymbol)}
      </Styled.Message>
      {!!total && <ProgressBar fillPercent={(total / threshold) * 100} />}
    </Styled.FreeShippingProgress>
  );
};

FreeShippingProgress.propTypes = {
  /**
   * Currency Code for User's Country
   */
  currencyCode: PropTypes.string,
  /**
   * Currency Symbol for User's Country. Either $ or CA$.
   */
  currencySymbol: PropTypes.oneOf(['$', 'CA$']),
  /**
   * dollar amount needed to achieve 100% progress
   */
  threshold: PropTypes.number.isRequired,
  /**
   * dollar amount of order that qualifies for free shipping
   */
  total: PropTypes.number.isRequired,
  /**
   * Shipping method available for free shipping
   */
  method: PropTypes.string
};

FreeShippingProgress.defaultProps = {
  currencyCode: null,
  currencySymbol: null,
  method: 'US'
};

export default FreeShippingProgress;
